/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import {
  analytics,
  isMobile,
  MembershipCancelledStatusId,
} from '../../utils/common';
import {
  BOOKING_FLOWS,
  BOOKING_SCREENS,
  withBookingAttributionQuery,
} from '../../utils/booking-attribution';
import makeSelectAppointment from '../Appointment/selectors';
import makeSelectMembership from '../Membership/selectors';
import { logoutUser } from '../User/actions';
import { makeSelectUser } from '../User/selectors';

class Mainmenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.applyMarginBasedOnRoute = this.applyMarginBasedOnRoute.bind(this);
  }

  renderLink = (
    link,
    handleMenuClick,
    klass = 'nav__page-link nav__page-link--large',
  ) => {
    if (link.newTab) {
      return (
        <div key={link.id} className={klass}>
          <a
            target="_blank"
            href={link.href}
            onClick={() => {
              handleMenuClick(link);
              analytics(
                `Menu - ${link.segmentEvent}`,
                {
                  Logged_In: this.isLoggedIn() ? 'TRUE' : 'FALSE',
                },
                true,
              );
            }}
          >
            {link.label}
          </a>
        </div>
      );
    }
    return (
      <div key={link.id} className={klass}>
        <Link
          href={link.href}
          to={link.href}
          onClick={() => {
            handleMenuClick(link);
            analytics(
              `Menu - ${link.segmentEvent}`,
              {
                Logged_In: this.isLoggedIn() ? 'TRUE' : 'FALSE',
              },
              true,
            );
          }}
        >
          {link.label}
        </Link>
      </div>
    );
  };

  menuItemsGeneral = [
    {
      id: 1,
      label: 'Book a Massage',
      href: withBookingAttributionQuery('/appointment/locations', {
        flow: BOOKING_FLOWS.BROWSE,
        screen: BOOKING_SCREENS.MAIN_MENU,
      }),
      segmentEvent: 'Book a Massage',
    },
    {
      id: 2,
      label: 'Own a Squeeze',
      href: 'https://squeezemassagefranchise.com',
      segmentEvent: 'Own a Squeeze',
      newTab: true,
    },
    { id: 3, label: 'Pricing', href: '/pricing', segmentEvent: 'Pricing' },
    {
      id: 4,
      label: 'Locations',
      href: '/appointment/locations?purchase_funnel=false',
      segmentEvent: 'Locations',
    },
    {
      id: 5,
      label: 'Therapists',
      href: '/therapist/list',
      segmentEvent: 'Therapists',
    },
    {
      id: 6,
      label: 'Become a Member',
      href: withBookingAttributionQuery(
        '/appointment/locations?purchase_funnel=false',
        {
          flow: BOOKING_FLOWS.BROWSE,
          screen: BOOKING_SCREENS.MEMBERSHIP_BANNER,
        },
      ),
      segmentEvent: 'Become a Member',
    },
    {
      id: 7,
      label: 'Gift Cards',
      href: '/gift/bucks',
      segmentEvent: 'Gift Cards',
    },
  ];

  menuItemSubMobile = [
    // {
    //   id: 8,
    //   label: 'About Us',
    //   href: '/about-us',
    //   segmentEvent: 'About Us',
    // },
    // {
    //   id: 9,
    //   label: 'Gallery',
    //   href: '/gallery',
    //   segmentEvent: 'Gallery',
    // },
    // {
    //   id: 10,
    //   label: 'Press',
    //   href: '/press',
    //   segmentEvent: 'Press',
    // },
    {
      id: 11,
      label: 'Careers',
      href: '/careers',
      segmentEvent: 'Careers',
    },
    // {
    //   id: 11,
    //   label: 'Careers',
    //   href: '/new-careers',
    //   segmentEvent: 'Careers',
    // },
    // {
    //   id: 12,
    //   label: 'FAQ',
    //   href:
    //     'https://squeezemassage.zendesk.com/hc/en-us/sections/360002009952-FAQs',
    //   segmentEvent: 'FAQ',
    //   newTab: true,
    // },
    {
      id: 13,
      label: 'Help',
      href: 'https://squeezemassage.zendesk.com/hc/en-us',
      segmentEvent: 'Help',
      newTab: true,
    },
    // {
    //   id: 14,
    //   label: 'Login',
    //   href: '/login',
    //   segmentEvent: 'Login',
    // },
    // {
    //   id: 15,
    //   label: 'Sign Up',
    //   href: '/register',
    //   segmentEvent: 'Sign Up',
    // },
  ];

  menuItemSub = [
    {
      id: 11,
      label: 'Careers',
      href: '/careers',
      segmentEvent: 'Careers',
    },
    {
      id: 13,
      label: 'Help',
      href: 'https://squeezemassage.zendesk.com/hc/en-us',
      segmentEvent: 'Help',
      newTab: true,
    },
  ];

  menuItemsUser = [
    {
      id: 1,
      label: 'Book a Massage',
      href: withBookingAttributionQuery('/appointment/locations', {
        flow: BOOKING_FLOWS.BROWSE,
        screen: BOOKING_SCREENS.MAIN_MENU,
      }),
      segmentEvent: 'Book a Massage',
    },
    {
      id: 2,
      label: 'Own a Squeeze',
      href: 'https://squeezemassagefranchise.com',
      segmentEvent: 'Own a Squeeze',
      newTab: true,
    },
    {
      id: 3,
      label: 'My Appointments',
      href: '/appointments',
      segmentEvent: 'My Appointments',
    },
    {
      id: 4,
      label: 'My Profile',
      href: '/profile',
      segmentEvent: 'My Profile',
    },
    {
      id: 5,
      label: 'My Preferences',
      href: '/preferences?from=menu',
      segmentEvent: 'My Preferences',
    },
    {
      id: 6,
      label: 'My Therapists',
      href: '/my-therapists',
      segmentEvent: 'My Therapists',
    },
    {
      id: 7,
      label: 'Become a Member',
      href: withBookingAttributionQuery(
        '/appointment/locations?purchase_funnel=false',
        {
          flow: BOOKING_FLOWS.BROWSE,
          screen: BOOKING_SCREENS.MEMBERSHIP_BANNER,
        },
      ),
      segmentEvent: 'Become a Member',
    },
    {
      id: 8,
      label: 'Gift Cards',
      href: '/gift/bucks',
      segmentEvent: 'Gift Cards',
    },
    {
      id: 9,
      label: 'Invite Friends',
      href: '/invite',
      segmentEvent: 'Invite Friends',
    },
  ];

  menuItemsMember = [
    {
      id: 1,
      label: 'Book a Massage',
      href: withBookingAttributionQuery('/appointment/locations', {
        flow: BOOKING_FLOWS.BROWSE,
        screen: BOOKING_SCREENS.MAIN_MENU,
      }),
      segmentEvent: 'Book a Massage',
    },
    {
      id: 2,
      label: 'Own a Squeeze',
      href: 'https://squeezemassagefranchise.com',
      segmentEvent: 'Own a Squeeze',
      newTab: true,
    },
    {
      id: 3,
      label: 'My Appointments',
      href: '/appointments',
      segmentEvent: 'My Appointments',
    },
    {
      id: 4,
      label: 'My Membership',
      href: '/membership',
      segmentEvent: 'My Membership',
    },
    {
      id: 5,
      label: 'My Profile',
      href: '/profile',
      segmentEvent: 'My Profile',
    },
    {
      id: 6,
      label: 'My Preferences',
      href: '/preferences?from=menu',
      segmentEvent: 'My Preferences',
    },
    {
      id: 7,
      label: 'My Therapists',
      href: '/my-therapists',
      segmentEvent: 'My Therapists',
    },
    {
      id: 8,
      label: 'Gift Cards',
      href: '/gift/bucks',
      segmentEvent: 'Gift Cards',
    },
    {
      id: 9,
      label: 'Invite Friends',
      href: '/invite',
      segmentEvent: 'Invite Friends',
    },
  ];

  menuMemberItemSub = [
    {
      id: 12,
      label: 'Locations',
      href: '/appointment/locations?purchase_funnel=false',
      segmentEvent: 'Locations',
    },
    {
      id: 13,
      label: 'Meet Our Therapists',
      href: '/therapist/list',
    },
    {
      id: 14,
      label: 'Pricing',
      href: this.isMember() ? '/membership' : '/pricing',
      segmentEvent: 'Pricing',
    },
    {
      id: 16,
      label: 'Help',
      href: 'https://squeezemassage.zendesk.com/hc/en-us',
      segmentEvent: 'FAQ',
      newTab: true,
    },
  ];

  isLoggedIn() {
    const {
      user: { userData },
    } = this.props;
    return !isEmpty(userData);
  }

  isMember() {
    const {
      user: { userData },
      membershipData: { membershipDetails },
    } = this.props;
    const activeMembership =
      membershipDetails && membershipDetails.status === 'active';
    return (
      Number(userData.has_membership) === 1 ||
      activeMembership ||
      (membershipDetails &&
        membershipDetails.entity_status_id &&
        Number(
          membershipDetails.entity_status_id !== MembershipCancelledStatusId,
        ))
    );
  }

  shouldRenderMyTherapist() {
    const { myStatus, fetchingStatus } = this.props.appointmentData;
    const completeAppointmentsCount =
      !fetchingStatus && myStatus && myStatus.hasCompletedAppointments;
    return completeAppointmentsCount;
  }

  renderAnonymousMenu() {
    // if (isMobile()) {
    //   this.menuItemsGeneral.push({
    //     id: this.menuItemsGeneral[this.menuItemsGeneral.length - 1] + 1,
    //     label: 'Own a Squeeze',
    //     href: '/franchising',
    //   });
    // }
    const menuItems = isMobile() ? this.menuItemSubMobile : this.menuItemSub;
    return (
      <React.Fragment>
        {this.menuItemsGeneral.map(item =>
          this.renderLink(item, this.props.handleMenuClick),
        )}
        {menuItems.map((item, index) => {
          let klass = 'nav__page-link';
          if (index === 0) {
            klass += ' nav__page-link-first';
          }
          return this.renderLink(item, this.props.handleMenuClick, klass);
        })}
      </React.Fragment>
    );
  }

  renderMemberMenu() {
    const optionsToMap =
      this.isLoggedIn() && !this.isMember()
        ? this.menuItemsUser
        : this.menuItemsMember;
    return (
      <React.Fragment>
        {optionsToMap.map(item => {
          if (
            !(item.label === 'My Therapists' && !this.shouldRenderMyTherapist())
          ) {
            return this.renderLink(item, this.props.handleMenuClick);
          }
          return <div key={item.id} />;
        })}
        {/* <h3
          className="phone-only nav__page-link--large logOutMobileMenu"
          onClick={() => this.props.logoutUser(this.props.history)}
        >
          Log out
        </h3> */}
        {this.menuMemberItemSub.map((item, index) => {
          let klass = 'nav__page-link';
          if (index === 0) {
            klass += ' nav__page-link-first';
          }
          return this.renderLink(item, this.props.handleMenuClick, klass);
        })}
      </React.Fragment>
    );
  }

  applyMarginBasedOnRoute(pathname) {
    // if (pathname === '/franchising') {
    //   return isMobile() ? { marginTop: '1rem' } : { marginTop: '4rem' };
    // } else
    if (
      pathname === '/pricing' ||
      pathname === '/appointment/locations' ||
      pathname.includes('/appointment/location') ||
      pathname === '/appointments' ||
      pathname === '/my-therapists' ||
      pathname === '/profile' ||
      pathname === '/invite' ||
      pathname === '/how-it-works' ||
      pathname === '/login' ||
      pathname === '/register' ||
      pathname === '/careers' ||
      pathname === '/about-us' ||
      pathname === '/privacy-policy' ||
      pathname === '/terms-of-use' ||
      pathname === '/preferences/summary' ||
      pathname === '/appointment/booked' ||
      pathname === '/gift/purchase-complete'
    ) {
      return isMobile() ? { marginTop: '0rem' } : { marginTop: '-3rem' };
    } else if (pathname === '/membership') {
      return isMobile() ? { marginTop: '1rem' } : { marginTop: '0rem' };
    } else if (pathname === '/membership/purchase-complete') {
      return isMobile() ? { marginTop: '3rem' } : { marginTop: '4rem' };
    }
    return {};
  }

  render() {
    return (
      <div
        id="navMenu"
        className="nav"
        style={this.applyMarginBasedOnRoute(this.props.location.pathname)}
      >
        <div className="nav__container container">
          <div className="nav__page-links logged-out-txt">
            {this.isLoggedIn()
              ? this.renderMemberMenu()
              : this.renderAnonymousMenu()}

            <div className="nav__page-link nav__page-link--social">
              <a
                href="https://www.facebook.com/squeezemassage/"
                target="_blank"
                onClick={() => {
                  analytics('Menu - Facebook', {
                    Logged_In: this.isLoggedIn() ? 'TRUE' : 'FALSE',
                  });
                }}
              >
                <i className="icon icon--facebook" />
              </a>
              <a
                href="https://twitter.com/squeezemassage"
                target="_blank"
                onClick={() => {
                  analytics('Menu - Twitter', {
                    Logged_In: this.isLoggedIn() ? 'TRUE' : 'FALSE',
                  });
                }}
              >
                <i className="icon icon--twitter" />
              </a>
              <a
                href="https://www.linkedin.com/company/squeeze-massage"
                target="_blank"
                onClick={() => {
                  analytics('Menu - LinkedIn', {
                    Logged_In: this.isLoggedIn() ? 'TRUE' : 'FALSE',
                  });
                }}
              >
                <i className="icon icon--linkedin" />
              </a>
              <a
                href="https://www.instagram.com/squeeze/"
                target="_blank"
                onClick={() => {
                  analytics('Menu - Instagram', {
                    Logged_In: this.isLoggedIn() ? 'TRUE' : 'FALSE',
                  });
                }}
              >
                <i className="icon icon--instagram" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Mainmenu.propTypes = {
  user: PropTypes.object,
  membershipData: PropTypes.object,
  location: PropTypes.object,
  appointmentData: PropTypes.object,
  handleMenuClick: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
  user: makeSelectUser(),
  membershipData: makeSelectMembership(),
});

const withConnect = connect(
  mapStateToProps,
  { logoutUser },
);

export default compose(
  withConnect,
  withRouter,
)(Mainmenu);
